<template>
  <div>
    <div v-if="loading" class="loading-md bg">
      <i class="fas fa-spinner inner"></i>
      <br />
      <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
        {{ loadingText }}
      </div>
    </div>
    <div v-else class="full">
      <div class="full">
        <div class="mainheader">{{ $t('employee.comp.billingRelevantData') }}</div>
      </div>
      <div class="half left">
        <div class="full split-bottom-tight">
          <div class="header">
            <div class="label">{{ $t('employee.comp.socialInsuranceRelevant') }}</div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.comp.childrenForPvBonus') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing}">
              <input :readonly="!editing" type="text" v-model="savedEmployeeBillingData.svChildren" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.comp.statutoryHealthInsurance') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing}">
              <input :readonly="!editing" type="text" v-model="savedEmployeeBillingData.svMandatoryHealthInsurance" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.comp.voluntaryHealthInsurance') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing}">
              <input :readonly="!editing" type="text" v-model="savedEmployeeBillingData.svVoluntaryHealthInsurance" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.comp.privateHealthInsurance') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing}">
              <input :readonly="!editing" type="text" v-model="savedEmployeeBillingData.svPrivateHealthInsurance" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.comp.rvExemptionFiled') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing}">
              <input :readonly="!editing" type="text" v-model="savedEmployeeBillingData.svPensionFundWaiverAvailable" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.comp.diseases') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing}">
              <input :readonly="!editing" type="text" v-model="savedEmployeeBillingData.svMaladies" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.comp.pensionNotice') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing}">
              <input :readonly="!editing" type="text" v-model="savedEmployeeBillingData.svPensionNotice" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.comp.garnishments') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing}">
              <input :readonly="!editing" type="text" v-model="savedEmployeeBillingData.svDistraints" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.comp.parentalLeave') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing}">
              <input :readonly="!editing" type="text" v-model="savedEmployeeBillingData.svParentalLeave" />
            </div>
          </div>

        </div>

        <div class="full split-bottom-tight">
          <div class="header">
            <div class="label">{{ $t('employee.comp.education') }}</div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.comp.schoolGraduation') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing}">
              <input :readonly="!editing" type="text" v-model="savedEmployeeBillingData.edSchoolQualification" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.comp.trainingGraduation') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing}">
              <input :readonly="!editing" type="text" v-model="savedEmployeeBillingData.edTrainingQualification" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.comp.previousActivities') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing}">
              <input :readonly="!editing" type="text" v-model="savedEmployeeBillingData.edPreviousExperience" />
            </div>
          </div>
        </div>
      </div>
      <div class="half right no-float">
        <div class="full split-bottom-tight">
          <div class="header">
            <div class="label">{{ $t('employee.comp.employment') }}</div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.comp.receivesUnemploymentBenefits') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing}">
              <input :readonly="!editing" type="text" v-model="savedEmployeeBillingData.empUnemploymentBenefit" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.comp.previousEmploymentStatus') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing}">
              <input :readonly="!editing" type="text" v-model="savedEmployeeBillingData.empCurrentEmployment" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.comp.otherEmployment') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing}">
              <input :readonly="!editing" type="text" v-model="savedEmployeeBillingData.empOtherEmployments" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.comp.multipleEmployment') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing}">
              <input :readonly="!editing" type="text" v-model="savedEmployeeBillingData.empMultipleEmployments" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.comp.salary') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing}">
              <input :readonly="!editing" type="text" v-model="savedEmployeeBillingData.empPayment" />
            </div>
          </div>
        </div>

        <div class="full split-bottom-tight">
          <div class="header">
            <div class="label">{{ $t('employee.comp.taxInformation') }}</div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.comp.taxClass') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing}">
              <input :readonly="!editing" type="text" v-model="savedEmployeeBillingData.taxClass" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
                <div class="label">{{ $t('employee.comp.religion') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing}">
              <input :readonly="!editing" type="text" v-model="savedEmployeeBillingData.taxConfession" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
                <div class="label">{{ $t('employee.comp.identificationNumber') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing}">
              <input :readonly="!editing" type="text" v-model="savedEmployeeBillingData.taxId" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
                <div class="label">{{ $t('employee.comp.childAllowance') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing}">
              <input :readonly="!editing" type="text" v-model="savedEmployeeBillingData.taxChildAbatement" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dropdownsearch from "../uicomponents/dropdownsearch.vue";
import {mapGetters} from "vuex";

export default {
  components: {
    dropdownsearch,
  },
  name: "employeebillingdata",
  data() {
    return {
      loading: false,
      loadingText:   this.$t('employee.comp.dataUpdating'),
      dragWatch: -1,
      mouseCurrent: {
        x: 0,
        y: 0,
      },
      mouseDragStart: {
        x: 0,
        y: 0,
      },
      scrolling: false,
      scrollTop: 150,
      dropdowns: [],
      savedEmployee: {},
      savedEmployeeBillingData: {},
      pendingChanges: false,
      editing: false,
    };
  },
  watch: {
    savedEmployee: {
      deep: true,
      handler(val, old) {
        if (val.storeId == null || val.storeId == undefined) {
          val.storeId = null;
        }
        this.checkForPendingChanges();
      },
    },
    savedEmployeeBillingData: {
      deep: true,
      handler(val, old) {
        // console.log("saved billing data changed", val);
        this.checkForPendingChanges();
      },
    },
    employee: function (val, oldVal) {
      this.editing = this.false;
      this.savedEmployee = Object.assign({}, this.employee);
      if (this.employeeBillingData == null) {
        this.initiateEmptyBillingData();
      } else {
        this.savedEmployeeBillingData = Object.assign({}, this.employeeBillingData);
      }
    },
  },
  props: ["employee", "employeeBillingData"],
  computed: {...mapGetters([])},
  mounted() {
    let view = this;
    console.log("Mounted EmployeeBillingData");

    this.savedEmployee = Object.assign({}, this.employee);
    if (this.employeeBillingData == null) {
      this.initiateEmptyBillingData();
    } else {
      this.savedEmployeeBillingData = Object.assign({}, this.employeeBillingData);
    }
    this.editing = false;

  },
  destroyed() {},
  methods: {
    initiateEmptyBillingData() {
      this.savedEmployeeBillingData = {
        companyId: this.$store.state.companyId,
        employeeId: this.savedEmployee.id,
        svChildren: null,
        svMandatoryHealthInsurance: null,
        svVoluntaryHealthInsurance: null,
        svPrivateHealthInsurance: null,
        svPensionFundWaiverAvailable: null,
        svMaladies: null,
        svPensionNotice: null,
        svDistraints: null,
        svParentalLeave: null,
        edSchoolQualification: null,
        edTrainingQualification: null,
        edPreviousExperience: null,
        employmentReceivesUnemploymentBenefits: null,
        empCurrentEmployment: null,
        empOtherEmployments: null,
        empMultipleEmployments: null,
        empPayment: null,
        taxClass: null,
        taxConfession: null,
        taxId: null,
        taxChildAbatement: null,
      };
    },
    toggleEditMode() {
      this.editing = !this.editing;
    },
    cancelEditMode() {
      this.savedEmployee = Object.assign({}, this.employee);
      if (this.employeeBillingData == null) {
        this.initiateEmptyBillingData();
      } else {
        this.savedEmployeeBillingData = Object.assign({}, this.employeeBillingData);
      }
      this.editing = false;
      this.$emit("billingdata-edit-cancelled");
    },
    checkForPendingChanges() {
      var keys = Object.keys(this.savedEmployeeBillingData);
      var changedKeys = [];
      keys.forEach((key) => {
        if (key !== "updated_at" && key !== "created_at") {
          if (!this.employeeBillingData || !(key in this.employeeBillingData) || this.savedEmployeeBillingData[key] != this.employeeBillingData[key]) {
            // if (this.employeeBillingData) {
            //   console.log("changed key:", key, "from", this.employeeBillingData[key], "to", this.savedEmployeeBillingData[key]);
            // } else {
            //   console.log("changed key:", key, "from null to", this.savedEmployeeBillingData[key]);
            // }
            changedKeys.push(key);
          }
        }
      });
      this.pendingChanges = changedKeys.length > 0;
      return changedKeys;
    },
    updateEmployeeBillingData() {
      let view = this;
      view.loadingText = view.$t('employee.comp.dataSaving');
      view.loading = true;
      // console.log("payload", view.savedEmployeeBillingData);
      let promise = null;
      if (view.savedEmployeeBillingData.hasOwnProperty("id")) {
        // existing billing data - update
        let url = "/sec/employee/billingdata/" + view.savedEmployeeBillingData.id;
        promise = view.api.put(url, view.savedEmployeeBillingData);
      } else {
        let url = "/sec/employee/billingdata";
        promise = view.api.post(url, view.savedEmployeeBillingData);
      }
      promise.then((response) => {
        // console.log(response);
        if (response.status == 200) {
            view.$helpers.success(
                view.$t('global.ui.success'),
                view.$t('employee.comp.changesSaved')
            );
            if (this.employeeBillingData == null) {
            view.$emit("billingdata-updated", response.data);
          } else {
            let keys = Object.keys(response.data);
            keys.forEach(key => {
              view.employeeBillingData[key] = response.data[key];
            });
            view.$emit("billingdata-updated");
            view.checkForPendingChanges();
            view.$forceUpdate();
          }
          view.savedEmployeeBillingData = Object.assign({}, response.data);
        }
        view.loading = false;
        view.editing = false;
      })
      .catch(function (error) {
        view.loading = false;
        console.log(error);
        console.log(error.message);
        view.$helpers.error(error.message);
      });
    },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.dropdown-search.filters {
  height: 25px !important;
  margin-top: -4px;
  display: block;
}

.input-component {
  text-align: left;
}

.checkbox-component {
  margin-top: -5px;
}

/*
.content *:not(.main-settings)>.half {
    height: 105px;
}
*/
</style>
